import { compose, withHandlers, withState } from "recompose";
import { withTranslator } from "app/decorators";
import CheckoutDetail from "./CheckoutDetail";

const onCheck = props => (e, isInputChecked) => {
  props.setIsInputChecked(isInputChecked);
};

export default compose(
  withState("isInputChecked", "setIsInputChecked", false),
  withHandlers({ onCheck }),
  withTranslator
)(CheckoutDetail);



// WEBPACK FOOTER //
// ./src/app/components/CheckoutCart/CheckoutDetail/CheckoutDetailContainer.js